import React, { useEffect, useContext } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { AppStoreContext } from '../../context/appStoreContext';
import { ssoAuthenticate } from '../../utils/services/authAPI';
import { notifyVendorPostSsoLogin } from '../../utils/embedHelper';
import { verifySso } from '../../utils/services/ssoAPI';

// const redirectUrl = 'http://localhost:7000/redirect'; // TODO : Turn this on for localhost authentication
const redirectUrl = `${URL.FRONTEND_URL}/redirect`;

export const EmbedSsoLogin = () => {
  const { ssoAuthClient: authClient, ssoSetup } = useContext(AppStoreContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tenantNameParams = queryParams.get('tenant');

  useEffect(() => {
    if (!authClient) return;
    const startSso = async () => {
      const tenantName = tenantNameParams ?? ssoSetup.tenantName;
      // Initiate the sso login flow
      await authClient.fetchAuthorizationCode({
        tenant: tenantName,
        product: ssoSetup.product,
      });
    };
    startSso();
  }, [authClient, ssoSetup, tenantNameParams]);
  return <></>;
};

const SSOLogin = (props) => {
  const { ssoAuthClient: authClient, ssoSetup } = useContext(AppStoreContext);

  const { tenant: tenantNameParams } = useParams();
  const history = useHistory();

  useEffect(() => {
    const signIn = async () => {
      if (!authClient) return;
      const tenantName = tenantNameParams ?? ssoSetup.tenantName;
      const response = await verifySso(tenantName);
      if (response?.data?.ssoEnabled) {
        // store the from url before redirecting ... we need this to correctly initialize the oauthClient after getting redirected back from SSO Provider.
        // localStorage.setItem(APP_FROM_URL, from);
        // Initiate the login flow
        await authClient.fetchAuthorizationCode({
          tenant: tenantName,
          product: ssoSetup.product,
        });
      } else {
        history.push('/');
      }
    };
    signIn();
  }, [authClient, tenantNameParams, ssoSetup]);

  useEffect(() => {
    let didCancel = false;

    const loadSsoUser = async () => {
      if (!authClient) {
        return;
      }
      // setAuthStatus('FETCHING');
      if (authClient.isAuthorized()) {
        console.log(`authClient is already authorized : `, authClient);
        const tokenResponse = await authClient.getAccessToken();
        console.log({ tokenResponse });
        if (tokenResponse) {
          const response = await ssoAuthenticate(tokenResponse?.token?.value);
          if (response) {
            console.log("Response 1 :: ", response);
            notifyVendorPostSsoLogin(true);
            return;
          } else {
            notifyVendorPostSsoLogin(false);
          }
        } else {
          notifyVendorPostSsoLogin(false);
        }
      }
        try {
          const hasAuthCode = await authClient?.isReturningFromAuthServer();
          if (!hasAuthCode) {
            console.log('no auth code detected...');
          } else {
            console.log(authClient);
            const token = !didCancel ? await authClient?.getAccessToken() : null;
            console.log({ token });
            if (token) {
              const response = await ssoAuthenticate(token?.token?.value);
              if (response) {
                console.log("Response 2 :: ", response);
                notifyVendorPostSsoLogin(true);
              } else {
                notifyVendorPostSsoLogin(false);
              }
            } else {
              notifyVendorPostSsoLogin(false);
            }
          }
        } catch (err) {
          console.error(err);
          notifyVendorPostSsoLogin(false);
        } 
    };

    console.log(`running effect loadUser`);
    loadSsoUser();
    return () => {
      console.log(`cancelling effect`);
      didCancel = true;
    };
  }, [authClient]);

  return ( // TODO : Handle page for no sso configured
    <div />
  )
}

export default SSOLogin;